export default __webpack_public_path__ + "static/media/omelette.44ae534d.jpeg";